import { createClient } from '@/lib/supabase/client';

type RequestMagicLinkArgs = {
  email: string;
  redirectTo?: string;
  allowCreate?: boolean;
  context?: 'signin' | 'signup' | 'save';
};

export type MagicLinkResult =
  | { ok: true }
  | { ok: false; message: string; code?: 'user_not_found' | 'rate_limited' | 'generic' };

export async function requestMagicLink({
  email,
  redirectTo,
  allowCreate = true,
}: RequestMagicLinkArgs): Promise<MagicLinkResult> {
  const supabase = createClient();

  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser: allowCreate,
      ...(redirectTo ? { emailRedirectTo: redirectTo } : {}),
    },
  });

  if (!error) return { ok: true };

  const msg = error.message || 'Unable to send magic link';

  if (msg.toLowerCase().includes('security purposes')) {
    return { ok: false, message: msg, code: 'rate_limited' };
  }

  if (
    msg.includes('User not found') ||
    msg.includes('invalid') ||
    msg.includes('Signups not allowed') ||
    error.status === 400 ||
    error.status === 422
  ) {
    return { ok: false, message: "We couldn't find an account with that email.", code: 'user_not_found' };
  }

  return { ok: false, message: msg, code: 'generic' };
}

